<template>
  <h1 class="cmsc-page-title theme-border-primary-color">{{title}}</h1>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style>

</style>